import { L, vocabulary } from '../define.js';
/** D577 slice a — generated from the domain code lists; every vocabulary is typed against its source. */
export const SERVICE_CENTER_VIEWS_VOCABULARIES = [
    vocabulary('safety.evidence_content_type', '@vello/api-client EvidenceContentType', {
        audio: L('Áudio', 'Audio', 'Audio', 'Audio'),
        video: L('Vídeo', 'Video', 'Video', 'Video'),
        dashcam: L('Câmera do veículo', 'Vehicle camera', 'Cámara del vehículo', 'Telecamera del veicolo'),
        device_signal: L('Sinal do aparelho', 'Device signal', 'Señal del dispositivo', 'Segnale del dispositivo'),
    }),
    vocabulary('safety.evidence_state', '@vello/api-client EvidenceState', {
        STORED: L('Guardada', 'Stored', 'Guardada', 'Conservata'),
        DELETED: L('Excluída', 'Deleted', 'Eliminada', 'Eliminata'),
    }),
    vocabulary('service_center.governance_record_kind', '@vello/api-client ScGovernanceRecordKind', {
        lawful_basis: L('Base legal', 'Lawful basis', 'Base legal', 'Base giuridica'),
        dsar: L('Pedido de titular de dados', 'Data subject request', 'Solicitud del titular de datos', 'Richiesta dell’interessato'),
        red_team: L('Teste adversarial', 'Red-team test', 'Prueba adversarial', 'Test avversariale'),
    }),
    vocabulary('service_center.conversation_status', '@vello/api-client ConversationStatus', {
        open: L('Aberta', 'Open', 'Abierta', 'Aperta'),
        pending: L('Aguardando', 'Pending', 'Pendiente', 'In attesa'),
        resolved: L('Resolvida', 'Resolved', 'Resuelta', 'Risolta'),
        closed: L('Fechada', 'Closed', 'Cerrada', 'Chiusa'),
    }),
    vocabulary('service_center.link_subject', '@vello/api-client LinkSubject', {
        ride: L('Corrida', 'Ride', 'Viaje', 'Corsa'),
        food_order: L('Pedido de comida', 'Food order', 'Pedido de comida', 'Ordine di cibo'),
        delivery: L('Entrega', 'Delivery', 'Entrega', 'Consegna'),
        payment: L('Pagamento', 'Payment', 'Pago', 'Pagamento'),
        application: L('Cadastro de parceiro', 'Partner application', 'Alta de socio', 'Registrazione partner'),
    }),
    vocabulary('service_center.interaction_kind', '@vello/api-client InteractionKind', {
        message: L('Mensagem', 'Message', 'Mensaje', 'Messaggio'),
        note: L('Nota interna', 'Internal note', 'Nota interna', 'Nota interna'),
        event: L('Evento', 'Event', 'Evento', 'Evento'),
        action: L('Ação', 'Action', 'Acción', 'Azione'),
        handoff: L('Transferência', 'Handoff', 'Traspaso', 'Passaggio'),
        system: L('Sistema', 'System', 'Sistema', 'Sistema'),
    }),
    vocabulary('service_center.direction', '@vello/api-client Direction', {
        inbound: L('Recebida', 'Inbound', 'Recibida', 'In entrata'),
        outbound: L('Enviada', 'Outbound', 'Enviada', 'In uscita'),
        internal: L('Interna', 'Internal', 'Interna', 'Interna'),
    }),
    vocabulary('voice.callback_status', '@vello/api-client VoiceCallbackStatusView', {
        open: L('Em aberto', 'Open', 'Abierta', 'Aperta'),
        fulfilled: L('Atendida', 'Fulfilled', 'Atendida', 'Evasa'),
        cancelled: L('Cancelada', 'Cancelled', 'Cancelada', 'Annullata'),
    }),
    vocabulary('whatsapp.delivery_status', '@vello/api-client WhatsappDeliveryStatus', {
        queued: L('Na fila', 'Queued', 'En cola', 'In coda'),
        sent: L('Enviada', 'Sent', 'Enviada', 'Inviata'),
        delivered: L('Entregue', 'Delivered', 'Entregada', 'Consegnata'),
        read: L('Lida', 'Read', 'Leída', 'Letta'),
        failed: L('Falhou', 'Failed', 'Falló', 'Non riuscita'),
    }),
    vocabulary('whatsapp.quality_rating', '@vello/api-client WhatsappQualityRating', {
        GREEN: L('Alta', 'High', 'Alta', 'Alta'),
        YELLOW: L('Média', 'Medium', 'Media', 'Media'),
        RED: L('Baixa', 'Low', 'Baja', 'Bassa'),
    }),
    vocabulary('whatsapp.retry_action', '@vello/api-client WhatsappRetryAction', {
        retry: L('Tentar de novo', 'Try again', 'Reintentar', 'Riprova'),
        dead_letter: L('Enviar para falhas definitivas', 'Move to permanent failures', 'Enviar a fallos definitivos', 'Sposta tra i fallimenti definitivi'),
    }),
    vocabulary('webhook.delivery_attempt_state', '@vello/api-client DeliveryAttemptState', {
        PENDING: L('Pendente', 'Pending', 'Pendiente', 'In attesa'),
        DELIVERED: L('Entregue', 'Delivered', 'Entregado', 'Consegnato'),
        DLQ: L('Tentativas esgotadas', 'Attempts exhausted', 'Intentos agotados', 'Tentativi esauriti'),
    }),
];
//# sourceMappingURL=service-center-views.js.map